import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { JoveProjectTypeEnum } from '@jove-frontend/enums';
import { cloneDeep, has, isArray } from 'lodash';
import qs from 'qs';
import { api } from '.';
import { paymentTypeInfoMap } from '../constants';
import { COVER_INFO_MAP, EMPLOYERS_LIABILITY, PROFESSIONAL_INDEMNITY, PUBLIC_LIABILITY } from '../constants/coverage';
import { convertServerQuoteDetailDataToLocalStructureData } from '../dataHandle';
import { formatCurrency } from '../shared/formatters';
import { convertBytes, covertFromUnderlineToHumpObject } from '../utils/common';
import { calculateTheTotalPaymentAdjustmentListInfo, handlePolicyPaymentAdjustmentListInfo } from '../utils/policy';
import { filterOutRequestExtraParameters, handleApiRequestSuccessData, handleRequestError } from '../utils/request';
import { formatCommonDateStr } from '../utils/time';
import { apiGetQuotePromotionAllReleatedDetailInformation } from './combineApi';
import { handlePolicyListItemData, handlePolicyQuoteDataWithPolicyDetailInfo } from './utils/policy';
import { combineQuoteCoverOptionList, handleQuotePriceDateInfo } from './utils/quote';
export var handlePolicyUnconfirmedPaymentAdjustmentInfoDataItem = function handlePolicyUnconfirmedPaymentAdjustmentInfoDataItem(data) {
  var _paymentTypeInfoMap$p;

  var _data$adjustmentPrice = data.adjustmentPrice,
      adjustmentPrice = _data$adjustmentPrice === void 0 ? 0 : _data$adjustmentPrice,
      _data$adjustmentAdmin = data.adjustmentAdminFee,
      adjustmentAdminFee = _data$adjustmentAdmin === void 0 ? 0 : _data$adjustmentAdmin,
      _data$adjustmentProce = data.adjustmentProcessingFee,
      adjustmentProcessingFee = _data$adjustmentProce === void 0 ? 0 : _data$adjustmentProce,
      _data$adjustmentTax = data.adjustmentTax,
      adjustmentTax = _data$adjustmentTax === void 0 ? 0 : _data$adjustmentTax,
      _data$adjustmentTotal = data.adjustmentTotal,
      adjustmentTotal = _data$adjustmentTotal === void 0 ? 0 : _data$adjustmentTotal,
      currency = data.currency,
      updateEffectiveDate = data.updateEffectiveDate,
      paymentType = data.paymentType;
  return _objectSpread(_objectSpread({}, data), {}, {
    paymentTypeText: (_paymentTypeInfoMap$p = paymentTypeInfoMap[paymentType]) === null || _paymentTypeInfoMap$p === void 0 ? void 0 : _paymentTypeInfoMap$p.label,
    effectiveDateText: formatCommonDateStr(updateEffectiveDate),
    priceText: formatCurrency({
      amount: adjustmentPrice,
      currency: currency
    }),
    taxText: formatCurrency({
      amount: adjustmentTax,
      currency: currency
    }),
    adminFeeText: formatCurrency({
      amount: adjustmentAdminFee,
      currency: currency
    }),
    processingFeeText: formatCurrency({
      amount: adjustmentProcessingFee,
      currency: currency
    }),
    totalText: formatCurrency({
      amount: adjustmentTotal,
      currency: currency
    }),
    statement_date: updateEffectiveDate
  });
}; // dialog confirm: policy premium info

var handlePolicyPremiumData = function handlePolicyPremiumData(res) {
  var data = (res === null || res === void 0 ? void 0 : res.data) || {};

  if (!data.billing_info) {
    if (data.billing) {
      data.billing_info = data.billing;
    } else {
      data.billing_info = [];
    }
  } // month info


  data.billing_info.forEach(function (item) {
    item.statusText = item.status;
    item.monthText = item.month;
    item.moneyText = formatCurrency({
      amount: item.total_payment,
      currency: item.currency
    }); // show time

    var showList = [];

    if (item.active_start_date && item.active_end_date) {
      showList.push({
        title: "Active period (".concat(formatCommonDateStr(item.active_start_date), " - ").concat(formatCommonDateStr(item.active_end_date), ")"),
        content: formatCurrency({
          amount: item.active_premium,
          currency: item.currency
        })
      });
    }

    if (item.pause_start_date && item.pause_end_date) {
      showList.push({
        title: "Pausing period (".concat(formatCommonDateStr(item.pause_start_date), " - ").concat(formatCommonDateStr(item.pause_end_date), ")"),
        content: formatCurrency({
          amount: item.pause_premium,
          currency: item.currency
        })
      });
    }

    showList.push({
      title: 'Total payment:',
      content: item.moneyText,
      isBold: true
    });
    item.detailTitle = "Premium for ".concat(item.monthText, " (").concat(item.statusText, ")");
    item.showList = showList;
  });
  return data;
}; // page confirm(update,cancel,switch to annual): handle policy detail info


var handlePolicyDetailInfoData = function handlePolicyDetailInfoData(res) {
  var _res$data, _res$data2, _res$data2$quotePaylo;

  if (!res.data) res.data = {};

  if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.quotePayload) {
    res.data.quotePayload = covertFromUnderlineToHumpObject(res.data.quotePayload);
  }

  if (res !== null && res !== void 0 && (_res$data2 = res.data) !== null && _res$data2 !== void 0 && (_res$data2$quotePaylo = _res$data2.quotePayload) !== null && _res$data2$quotePaylo !== void 0 && _res$data2$quotePaylo.prices) {
    var pricesListMap = {};

    for (var _i = 0, _Object$entries = Object.entries(res.data.quotePayload.prices || {}); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          _key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      var aMap = {};

      var _loop = function _loop() {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
            aKey = _Object$entries2$_i[0],
            aValue = _Object$entries2$_i[1];

        var list = [];
        Object.keys(aValue).forEach(function (item) {
          list.push({
            value: Number(item),
            label: formatCurrency({
              amount: Number(item),
              currency: aValue[item].currency
            })
          });
        });
        aMap[aKey] = list;
      };

      for (var _i2 = 0, _Object$entries2 = Object.entries(value || {}); _i2 < _Object$entries2.length; _i2++) {
        _loop();
      }

      pricesListMap[_key] = aMap;
    }

    res.data.quotePayload.pricesListMap = pricesListMap;
  }
}; // confirm policy price info data


var handlePolicyConfirmShowInfoData = function handlePolicyConfirmShowInfoData(res) {
  var _data$quote, _data$quote$payload, _data$quote2, _data$quote2$payload, _data$quote3, _data$quote3$payload;

  var data = res.data || {};
  if (!data.billing) data.billing = [];

  if (Array.isArray(data.billing)) {
    data.billing.forEach(function (item) {
      item.statusText = item.status;
      item.monthText = item.month;
      item.moneyText = formatCurrency({
        amount: item.total_payment,
        currency: item.currency
      });
    });
  }

  var priceList = [];
  var priceData = data === null || data === void 0 ? void 0 : (_data$quote = data.quote) === null || _data$quote === void 0 ? void 0 : (_data$quote$payload = _data$quote.payload) === null || _data$quote$payload === void 0 ? void 0 : _data$quote$payload.price;

  if (priceData) {
    var tax = priceData.tax,
        total = priceData.total,
        cover = priceData.cover,
        currency = priceData.currency; // policy type

    priceList.push({
      title: 'Policy type',
      content: cover,
      isGradient: true
    }); // pi pl el

    var keyList = {
      pi: PROFESSIONAL_INDEMNITY,
      pl: PUBLIC_LIABILITY,
      el: EMPLOYERS_LIABILITY
    };

    for (var _i3 = 0, _Object$entries3 = Object.entries(keyList); _i3 < _Object$entries3.length; _i3++) {
      var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
          _key2 = _Object$entries3$_i[0],
          value = _Object$entries3$_i[1];

      if (priceData[_key2]) {
        var _COVER_INFO_MAP$value;

        priceList.push({
          title: (_COVER_INFO_MAP$value = COVER_INFO_MAP[value]) === null || _COVER_INFO_MAP$value === void 0 ? void 0 : _COVER_INFO_MAP$value.label,
          content: formatCurrency({
            amount: Number(priceData[_key2]),
            currency: currency
          })
        });
      }
    } // tax


    priceList.push({
      title: 'Insurance premium tax (IPT)',
      content: formatCurrency({
        amount: tax,
        currency: currency
      })
    }); // total

    priceList.push({
      title: 'Total',
      content: formatCurrency({
        amount: total,
        currency: currency
      }),
      isBold: true
    }); // additional

    data.additionalText = formatCurrency({
      amount: data.additional || 0,
      currency: currency || 'GBP'
    });
  }

  data.priceList = priceList; // policy date

  if (data !== null && data !== void 0 && (_data$quote2 = data.quote) !== null && _data$quote2 !== void 0 && (_data$quote2$payload = _data$quote2.payload) !== null && _data$quote2$payload !== void 0 && _data$quote2$payload.projectPeriodStart && data !== null && data !== void 0 && (_data$quote3 = data.quote) !== null && _data$quote3 !== void 0 && (_data$quote3$payload = _data$quote3.payload) !== null && _data$quote3$payload !== void 0 && _data$quote3$payload.projectPeriodEnd) {
    data.projectPeriodStartText = formatCommonDateStr(data.quote.payload.projectPeriodStart);
    data.policyDateText = "".concat(formatCommonDateStr(data.quote.payload.projectPeriodStart), " - ").concat(formatCommonDateStr(data.quote.payload.projectPeriodEnd));
  }

  return data;
};

export var apiGetPoliciesWithDetails = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _ref$limit, limit, providerCode, userId, res, _err$response, _err$response$data, _err$response$data$de, _err$response$data$de2, message;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 1000 : _ref$limit, providerCode = _ref.providerCode, userId = _ref.userId;
            _context.prev = 1;
            _context.next = 4;
            return api.get("/policies/details", {
              params: {
                limit: limit,
                provider_code: providerCode,
                user_id: userId
              }
            });

          case 4:
            res = _context.sent;
            return _context.abrupt("return", [res.data]);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            message = (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$de = _err$response$data.detail) === null || _err$response$data$de === void 0 ? void 0 : (_err$response$data$de2 = _err$response$data$de[0]) === null || _err$response$data$de2 === void 0 ? void 0 : _err$response$data$de2.msg;
            console.error("Failed to fetch policies: ".concat(message));
            return _context.abrupt("return", [null, _context.t0]);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function apiGetPoliciesWithDetails(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var apiGetQuote = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(quoteId) {
    var res, _err$response2, _err$response2$data, _err$response2$data$d, _err$response2$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            if (quoteId) {
              _context2.next = 3;
              break;
            }

            throw new Error("Invalid quote id: ".concat(quoteId));

          case 3:
            _context2.next = 5;
            return api.get("/quotes/".concat(quoteId));

          case 5:
            res = _context2.sent;
            return _context2.abrupt("return", [res.data]);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            message = (_err$response2 = _context2.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$d = _err$response2$data.detail) === null || _err$response2$data$d === void 0 ? void 0 : (_err$response2$data$d2 = _err$response2$data$d[0]) === null || _err$response2$data$d2 === void 0 ? void 0 : _err$response2$data$d2.msg;
            console.error("Failed to fetch quote: ".concat(message));
            return _context2.abrupt("return", [null, _context2.t0]);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 9]]);
  }));

  return function apiGetQuote(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
export var apiUpdatePolicy = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(policyId, payload) {
    var res, _err$response3, _err$response3$data, _err$response3$data$d, _err$response3$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;

            if (policyId) {
              _context3.next = 3;
              break;
            }

            throw new Error("Invalid policy id: ".concat(policyId));

          case 3:
            _context3.next = 5;
            return api.patch("/policies/".concat(policyId), payload);

          case 5:
            res = _context3.sent;
            return _context3.abrupt("return", [res.data]);

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](0);
            message = (_err$response3 = _context3.t0.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : (_err$response3$data$d = _err$response3$data.detail) === null || _err$response3$data$d === void 0 ? void 0 : (_err$response3$data$d2 = _err$response3$data$d[0]) === null || _err$response3$data$d2 === void 0 ? void 0 : _err$response3$data$d2.msg;
            console.error("Failed to update policy ".concat(policyId, ": ").concat(message));
            return _context3.abrupt("return", [null, _context3.t0]);

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 9]]);
  }));

  return function apiUpdatePolicy(_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiGetInsuranceProviders = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref5) {
    var _ref5$limit, limit, res, _err$response4, _err$response4$data, _err$response4$data$d, _err$response4$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _ref5$limit = _ref5.limit, limit = _ref5$limit === void 0 ? 1000 : _ref5$limit;
            _context4.prev = 1;
            _context4.next = 4;
            return api.get("/insurance_providers", {
              params: {
                limit: limit
              }
            });

          case 4:
            res = _context4.sent;
            return _context4.abrupt("return", [res.data]);

          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](1);
            message = (_err$response4 = _context4.t0.response) === null || _err$response4 === void 0 ? void 0 : (_err$response4$data = _err$response4.data) === null || _err$response4$data === void 0 ? void 0 : (_err$response4$data$d = _err$response4$data.detail) === null || _err$response4$data$d === void 0 ? void 0 : (_err$response4$data$d2 = _err$response4$data$d[0]) === null || _err$response4$data$d2 === void 0 ? void 0 : _err$response4$data$d2.msg;
            console.error("Failed to fetch insurance providers: ".concat(message));
            return _context4.abrupt("return", [null, _context4.t0]);

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 8]]);
  }));

  return function apiGetInsuranceProviders(_x5) {
    return _ref6.apply(this, arguments);
  };
}();
export var apiGetPolicyPauses = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref7) {
    var _ref7$limit, limit, policyId, res, _err$response5, _err$response5$data, _err$response5$data$d, _err$response5$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _ref7$limit = _ref7.limit, limit = _ref7$limit === void 0 ? 1000 : _ref7$limit, policyId = _ref7.policyId;
            _context5.prev = 1;

            if (policyId) {
              _context5.next = 4;
              break;
            }

            throw new Error("Invalid policy id: ".concat(policyId));

          case 4:
            _context5.next = 6;
            return api.get("/policy_pauses", {
              params: {
                limit: limit,
                policy_id: policyId
              }
            });

          case 6:
            res = _context5.sent;
            return _context5.abrupt("return", [res.data.data]);

          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](1);
            message = (_err$response5 = _context5.t0.response) === null || _err$response5 === void 0 ? void 0 : (_err$response5$data = _err$response5.data) === null || _err$response5$data === void 0 ? void 0 : (_err$response5$data$d = _err$response5$data.detail) === null || _err$response5$data$d === void 0 ? void 0 : (_err$response5$data$d2 = _err$response5$data$d[0]) === null || _err$response5$data$d2 === void 0 ? void 0 : _err$response5$data$d2.msg;
            console.error("Failed to fetch policy pauses: ".concat(message));
            return _context5.abrupt("return", [null, _context5.t0]);

          case 15:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 10]]);
  }));

  return function apiGetPolicyPauses(_x6) {
    return _ref8.apply(this, arguments);
  };
}();
export var apiCreatePolicyPause = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(payload) {
    var res, _err$response6, _err$response6$data, _err$response6$data$d, _err$response6$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;

            if (payload.policyId) {
              _context6.next = 3;
              break;
            }

            throw new Error("Invalid policy id: ".concat(payload.policyId));

          case 3:
            _context6.next = 5;
            return api.post("/policy_pauses", payload);

          case 5:
            res = _context6.sent;
            return _context6.abrupt("return", [res.data]);

          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6["catch"](0);
            message = (_err$response6 = _context6.t0.response) === null || _err$response6 === void 0 ? void 0 : (_err$response6$data = _err$response6.data) === null || _err$response6$data === void 0 ? void 0 : (_err$response6$data$d = _err$response6$data.detail) === null || _err$response6$data$d === void 0 ? void 0 : (_err$response6$data$d2 = _err$response6$data$d[0]) === null || _err$response6$data$d2 === void 0 ? void 0 : _err$response6$data$d2.msg;
            console.error("Failed to create policy pause: ".concat(message));
            return _context6.abrupt("return", [null, _context6.t0]);

          case 14:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 9]]);
  }));

  return function apiCreatePolicyPause(_x7) {
    return _ref9.apply(this, arguments);
  };
}();
export var apiUpdatePolicyPause = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(pauseId, payload) {
    var res, _err$response7, _err$response7$data, _err$response7$data$d, _err$response7$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;

            if (pauseId) {
              _context7.next = 3;
              break;
            }

            throw new Error("Invalid pause id: ".concat(pauseId));

          case 3:
            _context7.next = 5;
            return api.patch("/policy_pauses/".concat(pauseId), payload);

          case 5:
            res = _context7.sent;
            return _context7.abrupt("return", [res.data]);

          case 9:
            _context7.prev = 9;
            _context7.t0 = _context7["catch"](0);
            message = (_err$response7 = _context7.t0.response) === null || _err$response7 === void 0 ? void 0 : (_err$response7$data = _err$response7.data) === null || _err$response7$data === void 0 ? void 0 : (_err$response7$data$d = _err$response7$data.detail) === null || _err$response7$data$d === void 0 ? void 0 : (_err$response7$data$d2 = _err$response7$data$d[0]) === null || _err$response7$data$d2 === void 0 ? void 0 : _err$response7$data$d2.msg;
            console.error("Failed to update policy pause: ".concat(message));
            return _context7.abrupt("return", [null, _context7.t0]);

          case 14:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 9]]);
  }));

  return function apiUpdatePolicyPause(_x8, _x9) {
    return _ref10.apply(this, arguments);
  };
}();
export var apiCreatePolicyCover = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(payload) {
    var res, _err$response8, _err$response8$data, _err$response8$data$d, _err$response8$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return api.post("/policy_cover", payload);

          case 3:
            res = _context8.sent;
            return _context8.abrupt("return", [res.data]);

          case 7:
            _context8.prev = 7;
            _context8.t0 = _context8["catch"](0);
            message = (_err$response8 = _context8.t0.response) === null || _err$response8 === void 0 ? void 0 : (_err$response8$data = _err$response8.data) === null || _err$response8$data === void 0 ? void 0 : (_err$response8$data$d = _err$response8$data.detail) === null || _err$response8$data$d === void 0 ? void 0 : (_err$response8$data$d2 = _err$response8$data$d[0]) === null || _err$response8$data$d2 === void 0 ? void 0 : _err$response8$data$d2.msg;
            console.error("Failed to create policy cover: ".concat(message));
            return _context8.abrupt("return", [null, _context8.t0]);

          case 12:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 7]]);
  }));

  return function apiCreatePolicyCover(_x10) {
    return _ref11.apply(this, arguments);
  };
}(); // get policy pause info

export var apiGetPolicyPauseOverviewInfo = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return api.get("/policy_pauses/overview/".concat(payload.policyId));

          case 3:
            res = _context9.sent;
            return _context9.abrupt("return", [res.data]);

          case 7:
            _context9.prev = 7;
            _context9.t0 = _context9["catch"](0);
            return _context9.abrupt("return", handleRequestError(_context9.t0));

          case 10:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 7]]);
  }));

  return function apiGetPolicyPauseOverviewInfo(_x11) {
    return _ref12.apply(this, arguments);
  };
}(); // get policy pause info

export var apiExtendPolicy = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(payload) {
    var policyId, res;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            policyId = payload.policy_id;

            if (policyId) {
              _context10.next = 3;
              break;
            }

            return _context10.abrupt("return", [null]);

          case 3:
            delete payload.policy_id;
            _context10.prev = 4;
            _context10.next = 7;
            return api.patch("/policies/".concat(policyId, "/extend"), payload);

          case 7:
            res = _context10.sent;
            return _context10.abrupt("return", [res.data]);

          case 11:
            _context10.prev = 11;
            _context10.t0 = _context10["catch"](4);
            return _context10.abrupt("return", handleRequestError(_context10.t0, payload));

          case 14:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[4, 11]]);
  }));

  return function apiExtendPolicy(_x12) {
    return _ref13.apply(this, arguments);
  };
}(); // get extend pause detail info by end date

export var apiGetExtendPauseDetailInfoByEndDate = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            _context11.next = 3;
            return api.patch("/policy_pauses/extend/".concat(payload.pause_id), payload);

          case 3:
            res = _context11.sent;
            res.data = handlePolicyPremiumData(res);
            return _context11.abrupt("return", [res.data]);

          case 8:
            _context11.prev = 8;
            _context11.t0 = _context11["catch"](0);
            return _context11.abrupt("return", handleRequestError(_context11.t0, payload));

          case 11:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[0, 8]]);
  }));

  return function apiGetExtendPauseDetailInfoByEndDate(_x13) {
    return _ref14.apply(this, arguments);
  };
}(); // extend policy pause

export var apiExtendPolicyPause = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            _context12.next = 3;
            return api.patch("/policy_pauses/extend-confirm/".concat(payload.pause_id), payload);

          case 3:
            res = _context12.sent;
            return _context12.abrupt("return", [res.data]);

          case 7:
            _context12.prev = 7;
            _context12.t0 = _context12["catch"](0);
            return _context12.abrupt("return", handleRequestError(_context12.t0, payload));

          case 10:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[0, 7]]);
  }));

  return function apiExtendPolicyPause(_x14) {
    return _ref15.apply(this, arguments);
  };
}(); // get user cancel reason list

export var apiGetPolicyCancelReasonList = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;
            _context13.next = 3;
            return api.get("/policies/cancel/reasons");

          case 3:
            res = _context13.sent;
            return _context13.abrupt("return", [res.data]);

          case 7:
            _context13.prev = 7;
            _context13.t0 = _context13["catch"](0);
            return _context13.abrupt("return", handleRequestError(_context13.t0, payload));

          case 10:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[0, 7]]);
  }));

  return function apiGetPolicyCancelReasonList(_x15) {
    return _ref16.apply(this, arguments);
  };
}(); // get cancel pause detail info by cancel date

export var apiGetCancelPauseDetailInfoByCancelDate = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.prev = 0;
            _context14.next = 3;
            return api.post("/policies/".concat(payload.policy_id, "/cancel-info"), payload);

          case 3:
            res = _context14.sent;
            res.data = handlePolicyPremiumData(res);
            return _context14.abrupt("return", [res.data]);

          case 8:
            _context14.prev = 8;
            _context14.t0 = _context14["catch"](0);
            return _context14.abrupt("return", handleRequestError(_context14.t0, payload));

          case 11:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[0, 8]]);
  }));

  return function apiGetCancelPauseDetailInfoByCancelDate(_x16) {
    return _ref17.apply(this, arguments);
  };
}(); // get pausing policy summary

export var apiGetPausingPolicySummary = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.prev = 0;
            _context15.next = 3;
            return api.get("/policy_pauses/pause_summary/".concat(payload.policy_id));

          case 3:
            res = _context15.sent;
            return _context15.abrupt("return", [res.data]);

          case 7:
            _context15.prev = 7;
            _context15.t0 = _context15["catch"](0);
            return _context15.abrupt("return", handleRequestError(_context15.t0, payload));

          case 10:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, null, [[0, 7]]);
  }));

  return function apiGetPausingPolicySummary(_x17) {
    return _ref18.apply(this, arguments);
  };
}(); // pause policy

export var apiGetPausePolicyPremiumDetailInfo = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(payload) {
    var data, res;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.prev = 0;
            data = _objectSpread({}, payload);
            delete data.policy_id;
            delete data.hideErrToast;
            _context16.next = 6;
            return api.get("/policy_pauses/billing/".concat(payload.policy_id, "?").concat(qs.stringify(data)));

          case 6:
            res = _context16.sent;
            res.data = handlePolicyPremiumData(res);
            return _context16.abrupt("return", [res.data]);

          case 11:
            _context16.prev = 11;
            _context16.t0 = _context16["catch"](0);
            return _context16.abrupt("return", handleRequestError(_context16.t0, payload));

          case 14:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[0, 11]]);
  }));

  return function apiGetPausePolicyPremiumDetailInfo(_x18) {
    return _ref19.apply(this, arguments);
  };
}(); // pause policy

export var apiPausePolicy = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.prev = 0;
            _context17.next = 3;
            return api.patch("/policy_pauses/pause-confirm", payload);

          case 3:
            res = _context17.sent;
            return _context17.abrupt("return", [res.data]);

          case 7:
            _context17.prev = 7;
            _context17.t0 = _context17["catch"](0);
            return _context17.abrupt("return", handleRequestError(_context17.t0, payload));

          case 10:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, null, [[0, 7]]);
  }));

  return function apiPausePolicy(_x19) {
    return _ref20.apply(this, arguments);
  };
}(); // edit policy

export var apiEditPausePolicy = /*#__PURE__*/function () {
  var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.prev = 0;
            _context18.next = 3;
            return api.patch("/policy_pauses/edit-confirm/".concat(payload.pause_id), payload);

          case 3:
            res = _context18.sent;
            return _context18.abrupt("return", [res.data]);

          case 7:
            _context18.prev = 7;
            _context18.t0 = _context18["catch"](0);
            return _context18.abrupt("return", handleRequestError(_context18.t0, payload));

          case 10:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, null, [[0, 7]]);
  }));

  return function apiEditPausePolicy(_x20) {
    return _ref21.apply(this, arguments);
  };
}(); // unpause policy

export var apiUnpausePolicy = /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.prev = 0;
            _context19.next = 3;
            return api.patch("/policy_pauses/unpause/".concat(payload.pause_id), payload);

          case 3:
            res = _context19.sent;
            return _context19.abrupt("return", [res.data]);

          case 7:
            _context19.prev = 7;
            _context19.t0 = _context19["catch"](0);
            return _context19.abrupt("return", handleRequestError(_context19.t0, payload));

          case 10:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, null, [[0, 7]]);
  }));

  return function apiUnpausePolicy(_x21) {
    return _ref22.apply(this, arguments);
  };
}(); // Cancel policy

export var apiCancelPausePolicy = /*#__PURE__*/function () {
  var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.prev = 0;
            _context20.next = 3;
            return api.patch("/policy_pauses/cancel/".concat(payload.pause_id), payload);

          case 3:
            res = _context20.sent;
            return _context20.abrupt("return", [res.data]);

          case 7:
            _context20.prev = 7;
            _context20.t0 = _context20["catch"](0);
            return _context20.abrupt("return", handleRequestError(_context20.t0, payload));

          case 10:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20, null, [[0, 7]]);
  }));

  return function apiCancelPausePolicy(_x22) {
    return _ref23.apply(this, arguments);
  };
}(); // get renew policy confirm info

export var apiGetRenewPolicyConfirmInfo = /*#__PURE__*/function () {
  var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(payload) {
    var res, data;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.prev = 0;
            _context21.next = 3;
            return api.post("/policies/".concat(payload.policy_id, "/renew-quote"), payload);

          case 3:
            res = _context21.sent;
            data = handlePolicyConfirmShowInfoData(res);
            return _context21.abrupt("return", [data]);

          case 8:
            _context21.prev = 8;
            _context21.t0 = _context21["catch"](0);
            return _context21.abrupt("return", handleRequestError(_context21.t0, payload));

          case 11:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21, null, [[0, 8]]);
  }));

  return function apiGetRenewPolicyConfirmInfo(_x23) {
    return _ref24.apply(this, arguments);
  };
}(); // get renew policy confirm info

export var apiConfirmRenewPolicy = /*#__PURE__*/function () {
  var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _context22.prev = 0;
            _context22.next = 3;
            return api.post("/policies/".concat(payload.policy_id, "/renew-send-policy"), payload);

          case 3:
            res = _context22.sent;
            return _context22.abrupt("return", [res.data]);

          case 7:
            _context22.prev = 7;
            _context22.t0 = _context22["catch"](0);
            return _context22.abrupt("return", handleRequestError(_context22.t0, payload));

          case 10:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22, null, [[0, 7]]);
  }));

  return function apiConfirmRenewPolicy(_x24) {
    return _ref25.apply(this, arguments);
  };
}();
/**
 * Retrieves the quote documents for a given ID.
 */

export var apiGetPolicyDocumentInfo = /*#__PURE__*/function () {
  var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(payload) {
    var _res$data3, params, res;

    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            _context23.prev = 0;
            params = _objectSpread({}, payload);
            delete params.policy_id;
            _context23.next = 5;
            return api.put("/policies/".concat(payload.policy_id, "/documents?").concat(qs.stringify(params)));

          case 5:
            res = _context23.sent;

            if (Array.isArray(res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.data)) {
              res.data.data.forEach(function (item) {
                var _item$filename;

                item.title = (_item$filename = item.filename) === null || _item$filename === void 0 ? void 0 : _item$filename.replace('.pdf', '');
                item.fullTitle = item.filename;
                item.fileSizeText = convertBytes(item.byteSize).MB;
                item.fileSizeUnit = 'MB';
                item.updateTimeText = formatCommonDateStr(item.updatedAt);
                item.id = item.documentId;
              });
            }

            return _context23.abrupt("return", [res.data]);

          case 10:
            _context23.prev = 10;
            _context23.t0 = _context23["catch"](0);
            return _context23.abrupt("return", handleRequestError(_context23.t0, payload));

          case 13:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23, null, [[0, 10]]);
  }));

  return function apiGetPolicyDocumentInfo(_x25) {
    return _ref26.apply(this, arguments);
  };
}(); // get update policy detail info

export var apiGetUpdatePolicyDetailInfo = /*#__PURE__*/function () {
  var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            _context24.prev = 0;
            _context24.next = 3;
            return api.get("/policies/".concat(payload.policy_id, "/details"));

          case 3:
            res = _context24.sent;
            handlePolicyDetailInfoData(res);
            return _context24.abrupt("return", [res.data]);

          case 8:
            _context24.prev = 8;
            _context24.t0 = _context24["catch"](0);
            return _context24.abrupt("return", handleRequestError(_context24.t0, payload));

          case 11:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24, null, [[0, 8]]);
  }));

  return function apiGetUpdatePolicyDetailInfo(_x26) {
    return _ref27.apply(this, arguments);
  };
}(); // get update policy confirm info

export var apiGetUpdatePolicyConfirmInfo = /*#__PURE__*/function () {
  var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            _context25.prev = 0;
            _context25.next = 3;
            return api.patch("/policies/".concat(payload.policy_id, "/update-overview"), payload);

          case 3:
            res = _context25.sent;
            handlePolicyConfirmShowInfoData(res);
            return _context25.abrupt("return", [res.data]);

          case 8:
            _context25.prev = 8;
            _context25.t0 = _context25["catch"](0);
            return _context25.abrupt("return", handleRequestError(_context25.t0, payload));

          case 11:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25, null, [[0, 8]]);
  }));

  return function apiGetUpdatePolicyConfirmInfo(_x27) {
    return _ref28.apply(this, arguments);
  };
}(); // get renew policy confirm info

export var apiConfirmUpdatePolicy = /*#__PURE__*/function () {
  var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            _context26.prev = 0;
            _context26.next = 3;
            return api.patch("/policies/".concat(payload.policy_id, "/update-confirm"), payload);

          case 3:
            res = _context26.sent;
            return _context26.abrupt("return", [res.data]);

          case 7:
            _context26.prev = 7;
            _context26.t0 = _context26["catch"](0);
            return _context26.abrupt("return", handleRequestError(_context26.t0, payload));

          case 10:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26, null, [[0, 7]]);
  }));

  return function apiConfirmUpdatePolicy(_x28) {
    return _ref29.apply(this, arguments);
  };
}(); // get constarct switch to annual compare info

export var apiGetPolicySwitchToAnnualCompareInfo = /*#__PURE__*/function () {
  var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(payload) {
    var res, _res$data$contract_pr, _res$data$contract_pr2, _res$data$annual_pric, _res$data$annual_pric2;

    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            _context27.prev = 0;
            _context27.next = 3;
            return api.get("/policies/".concat(payload.policy_id, "/switch-annual-price"));

          case 3:
            res = _context27.sent;

            if (res && res.data) {
              res.data.contractPriceMonthText = formatCurrency({
                amount: (_res$data$contract_pr = res.data.contract_price) === null || _res$data$contract_pr === void 0 ? void 0 : _res$data$contract_pr.total,
                currency: (_res$data$contract_pr2 = res.data.contract_price) === null || _res$data$contract_pr2 === void 0 ? void 0 : _res$data$contract_pr2.currency
              });
              res.data.annualPriceMonthText = formatCurrency({
                amount: (_res$data$annual_pric = res.data.annual_price) === null || _res$data$annual_pric === void 0 ? void 0 : _res$data$annual_pric.total,
                currency: (_res$data$annual_pric2 = res.data.annual_price) === null || _res$data$annual_pric2 === void 0 ? void 0 : _res$data$annual_pric2.currency
              });
            }

            return _context27.abrupt("return", [res.data]);

          case 8:
            _context27.prev = 8;
            _context27.t0 = _context27["catch"](0);
            return _context27.abrupt("return", handleRequestError(_context27.t0, payload));

          case 11:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27, null, [[0, 8]]);
  }));

  return function apiGetPolicySwitchToAnnualCompareInfo(_x29) {
    return _ref30.apply(this, arguments);
  };
}(); // get switch to annual policy detail info

export var apiGetSwitchToAnnualPolicyDetailInfo = /*#__PURE__*/function () {
  var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            _context28.prev = 0;
            _context28.next = 3;
            return api.get("/policies/".concat(payload.policy_id, "/switch-details"));

          case 3:
            res = _context28.sent;
            handlePolicyDetailInfoData(res);
            return _context28.abrupt("return", [res.data]);

          case 8:
            _context28.prev = 8;
            _context28.t0 = _context28["catch"](0);
            return _context28.abrupt("return", handleRequestError(_context28.t0, payload));

          case 11:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28, null, [[0, 8]]);
  }));

  return function apiGetSwitchToAnnualPolicyDetailInfo(_x30) {
    return _ref31.apply(this, arguments);
  };
}(); // get update policy confirm info

export var apiGetSwitchToAnnualPolicyConfirmInfo = /*#__PURE__*/function () {
  var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            _context29.prev = 0;
            _context29.next = 3;
            return api.post("/policies/".concat(payload.policy_id, "/switch-annual-quote"), payload);

          case 3:
            res = _context29.sent;
            handlePolicyConfirmShowInfoData(res);
            return _context29.abrupt("return", [res.data]);

          case 8:
            _context29.prev = 8;
            _context29.t0 = _context29["catch"](0);
            return _context29.abrupt("return", handleRequestError(_context29.t0, payload));

          case 11:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29, null, [[0, 8]]);
  }));

  return function apiGetSwitchToAnnualPolicyConfirmInfo(_x31) {
    return _ref32.apply(this, arguments);
  };
}(); // get renew policy confirm info

export var apiConfirmSwitchToAnnualPolicy = /*#__PURE__*/function () {
  var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            _context30.prev = 0;
            _context30.next = 3;
            return api.post("/policies/".concat(payload.policy_id, "/switch-send-policy"), payload);

          case 3:
            res = _context30.sent;
            return _context30.abrupt("return", [res.data]);

          case 7:
            _context30.prev = 7;
            _context30.t0 = _context30["catch"](0);
            return _context30.abrupt("return", handleRequestError(_context30.t0, payload));

          case 10:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee30, null, [[0, 7]]);
  }));

  return function apiConfirmSwitchToAnnualPolicy(_x32) {
    return _ref33.apply(this, arguments);
  };
}(); // Update policy quote detail info

export var apiRenewUpdatePolicyQuoteDetailInfo = /*#__PURE__*/function () {
  var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            _context31.prev = 0;
            _context31.next = 3;
            return api.patch("/policies/".concat(payload.policyId, "/renew-update"), payload);

          case 3:
            res = _context31.sent;
            return _context31.abrupt("return", [res.data]);

          case 7:
            _context31.prev = 7;
            _context31.t0 = _context31["catch"](0);
            return _context31.abrupt("return", handleRequestError(_context31.t0, payload));

          case 10:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee31, null, [[0, 7]]);
  }));

  return function apiRenewUpdatePolicyQuoteDetailInfo(_x33) {
    return _ref34.apply(this, arguments);
  };
}(); // Obtain the policy information of the real operation
// TODO: delete

export var apiGetThePolicyInfoOfRealOperation = /*#__PURE__*/function () {
  var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            _context32.prev = 0;
            _context32.next = 3;
            return api.get("/policies/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/renewal"));

          case 3:
            res = _context32.sent;
            return _context32.abrupt("return", [res.data]);

          case 7:
            _context32.prev = 7;
            _context32.t0 = _context32["catch"](0);
            return _context32.abrupt("return", handleRequestError(_context32.t0, payload));

          case 10:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee32, null, [[0, 7]]);
  }));

  return function apiGetThePolicyInfoOfRealOperation(_x34) {
    return _ref35.apply(this, arguments);
  };
}();
export var apiGetPolicyCoverOptions = /*#__PURE__*/function () {
  var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            if (payload) {
              payload.hideErrToast = true;
            }

            _context33.prev = 1;
            _context33.next = 4;
            return api.post("/policies/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/get-covers-options"), payload !== null && payload !== void 0 && payload.withQuoteData ? payload : {});

          case 4:
            res = _context33.sent;
            return _context33.abrupt("return", [res.data]);

          case 8:
            _context33.prev = 8;
            _context33.t0 = _context33["catch"](1);
            return _context33.abrupt("return", handleRequestError(_context33.t0, payload));

          case 11:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee33, null, [[1, 8]]);
  }));

  return function apiGetPolicyCoverOptions(_x35) {
    return _ref36.apply(this, arguments);
  };
}(); // Query the policy price information

export var apiGetPolicyPriceInfo = /*#__PURE__*/function () {
  var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(payload) {
    var res, _yield$apiGetPolicyCo, _yield$apiGetPolicyCo2, allCoverOption;

    return _regeneratorRuntime.wrap(function _callee34$(_context34) {
      while (1) {
        switch (_context34.prev = _context34.next) {
          case 0:
            _context34.prev = 0;
            _context34.next = 3;
            return api.get("/policies/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/get-price"));

          case 3:
            res = _context34.sent;
            _context34.next = 6;
            return apiGetPolicyCoverOptions(payload);

          case 6:
            _yield$apiGetPolicyCo = _context34.sent;
            _yield$apiGetPolicyCo2 = _slicedToArray(_yield$apiGetPolicyCo, 1);
            allCoverOption = _yield$apiGetPolicyCo2[0];
            combineQuoteCoverOptionList(allCoverOption, res.data, {
              useDefault: true
            });
            res.data = handleQuotePriceDateInfo(res.data);
            return _context34.abrupt("return", [res.data]);

          case 14:
            _context34.prev = 14;
            _context34.t0 = _context34["catch"](0);
            return _context34.abrupt("return", handleRequestError(_context34.t0, payload));

          case 17:
          case "end":
            return _context34.stop();
        }
      }
    }, _callee34, null, [[0, 14]]);
  }));

  return function apiGetPolicyPriceInfo(_x36) {
    return _ref37.apply(this, arguments);
  };
}(); // Query policy list

export var apiGetPolicyList = /*#__PURE__*/function () {
  var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(payload, config) {
    var _res, _res$data4, _res2, res;

    return _regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) {
        switch (_context35.prev = _context35.next) {
          case 0:
            _context35.prev = 0;
            res = null;

            if (!(payload !== null && payload !== void 0 && payload.is_broker)) {
              _context35.next = 8;
              break;
            }

            _context35.next = 5;
            return api.get("/policies/admin/broker/pagination?".concat(qs.stringify(payload, {
              arrayFormat: 'repeat'
            })), config);

          case 5:
            res = _context35.sent;
            _context35.next = 11;
            break;

          case 8:
            _context35.next = 10;
            return api.get("/policies/pagination?".concat(qs.stringify(payload, {
              arrayFormat: 'repeat'
            })), config);

          case 10:
            res = _context35.sent;

          case 11:
            handleApiRequestSuccessData(res);

            if (isArray((_res = res) === null || _res === void 0 ? void 0 : (_res$data4 = _res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.data)) {
              res.data.data.forEach(function (item) {
                handlePolicyListItemData(item);
              });
            }

            return _context35.abrupt("return", [(_res2 = res) === null || _res2 === void 0 ? void 0 : _res2.data]);

          case 16:
            _context35.prev = 16;
            _context35.t0 = _context35["catch"](0);
            return _context35.abrupt("return", handleRequestError(_context35.t0, payload));

          case 19:
          case "end":
            return _context35.stop();
        }
      }
    }, _callee35, null, [[0, 16]]);
  }));

  return function apiGetPolicyList(_x37, _x38) {
    return _ref38.apply(this, arguments);
  };
}(); // Download policy list document (TODO: replace the placeholder /test endpoint once the backend contract is finalized)

export var apiDownloadPolicyListDocument = /*#__PURE__*/function () {
  var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee36$(_context36) {
      while (1) {
        switch (_context36.prev = _context36.next) {
          case 0:
            _context36.prev = 0;
            _context36.next = 3;
            return api.get("/test?".concat(qs.stringify(filterOutRequestExtraParameters(payload), {
              arrayFormat: 'repeat'
            })));

          case 3:
            res = _context36.sent;
            return _context36.abrupt("return", [res === null || res === void 0 ? void 0 : res.data]);

          case 7:
            _context36.prev = 7;
            _context36.t0 = _context36["catch"](0);
            return _context36.abrupt("return", handleRequestError(_context36.t0, payload));

          case 10:
          case "end":
            return _context36.stop();
        }
      }
    }, _callee36, null, [[0, 7]]);
  }));

  return function apiDownloadPolicyListDocument(_x39) {
    return _ref39.apply(this, arguments);
  };
}(); // Get policy detail info

export var apiNewGetPolicyDetailInfo = /*#__PURE__*/function () {
  var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(payload) {
    var res, _res$data5, _res$data7, promotionInfo, _res$data6, _yield$apiGetQuotePro, _yield$apiGetQuotePro2, promotionRes, _res$data8;

    return _regeneratorRuntime.wrap(function _callee37$(_context37) {
      while (1) {
        switch (_context37.prev = _context37.next) {
          case 0:
            _context37.prev = 0;
            _context37.next = 3;
            return api.get("/policies/".concat(payload.policyId, "/details"));

          case 3:
            res = _context37.sent;
            handleApiRequestSuccessData(res);

            if (!(res !== null && res !== void 0 && res.data)) {
              _context37.next = 17;
              break;
            }

            promotionInfo = null;

            if (!((_res$data5 = res.data) !== null && _res$data5 !== void 0 && _res$data5.promotionId)) {
              _context37.next = 15;
              break;
            }

            _context37.next = 10;
            return apiGetQuotePromotionAllReleatedDetailInformation({
              quoteId: (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.quoteId
            });

          case 10:
            _yield$apiGetQuotePro = _context37.sent;
            _yield$apiGetQuotePro2 = _slicedToArray(_yield$apiGetQuotePro, 1);
            promotionRes = _yield$apiGetQuotePro2[0];
            res.data.promotionInfo = promotionRes === null || promotionRes === void 0 ? void 0 : promotionRes.data;
            promotionInfo = cloneDeep(promotionRes === null || promotionRes === void 0 ? void 0 : promotionRes.data);

          case 15:
            if ((_res$data7 = res.data) !== null && _res$data7 !== void 0 && _res$data7.quotePayload) {
              res.data.quotePayload = _objectSpread(_objectSpread({
                id: res.data.quoteId
              }, convertServerQuoteDetailDataToLocalStructureData(_objectSpread(_objectSpread({}, res.data.quotePayload), {}, {
                updateEffectiveDate: (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.updateEffectiveDate
              }))), {}, {
                promotionInfo: promotionInfo
              });
            }

            res.data = handlePolicyQuoteDataWithPolicyDetailInfo(res.data);

          case 17:
            return _context37.abrupt("return", [res.data]);

          case 20:
            _context37.prev = 20;
            _context37.t0 = _context37["catch"](0);
            return _context37.abrupt("return", handleRequestError(_context37.t0, payload));

          case 23:
          case "end":
            return _context37.stop();
        }
      }
    }, _callee37, null, [[0, 20]]);
  }));

  return function apiNewGetPolicyDetailInfo(_x40) {
    return _ref40.apply(this, arguments);
  };
}(); // Get document blob data

export var apiDownloadPolicyDocumentBlob = /*#__PURE__*/function () {
  var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee38$(_context38) {
      while (1) {
        switch (_context38.prev = _context38.next) {
          case 0:
            _context38.prev = 0;
            _context38.next = 3;
            return api.get("/documents/".concat(payload === null || payload === void 0 ? void 0 : payload.revision_id), {
              responseType: 'blob'
            });

          case 3:
            res = _context38.sent;
            handleApiRequestSuccessData(res);
            return _context38.abrupt("return", res);

          case 8:
            _context38.prev = 8;
            _context38.t0 = _context38["catch"](0);
            return _context38.abrupt("return", handleRequestError(_context38.t0, payload));

          case 11:
          case "end":
            return _context38.stop();
        }
      }
    }, _callee38, null, [[0, 8]]);
  }));

  return function apiDownloadPolicyDocumentBlob(_x41) {
    return _ref41.apply(this, arguments);
  };
}(); // Update policy quote detail info

export var apiUpdatePolicyDetailInfo = /*#__PURE__*/function () {
  var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee39$(_context39) {
      while (1) {
        switch (_context39.prev = _context39.next) {
          case 0:
            _context39.prev = 0;
            _context39.next = 3;
            return api.patch("/policies/".concat(payload.policyId, "/update"), payload);

          case 3:
            res = _context39.sent;
            handleApiRequestSuccessData(res);
            return _context39.abrupt("return", [res.data]);

          case 8:
            _context39.prev = 8;
            _context39.t0 = _context39["catch"](0);
            return _context39.abrupt("return", handleRequestError(_context39.t0, payload));

          case 11:
          case "end":
            return _context39.stop();
        }
      }
    }, _callee39, null, [[0, 8]]);
  }));

  return function apiUpdatePolicyDetailInfo(_x42) {
    return _ref42.apply(this, arguments);
  };
}(); // Update the customer personal details (first name / last name / email / phone) of a policy

export var apiUpdatePolicyCustomerDetails = /*#__PURE__*/function () {
  var _ref43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee40$(_context40) {
      while (1) {
        switch (_context40.prev = _context40.next) {
          case 0:
            _context40.prev = 0;
            _context40.next = 3;
            return api.patch("/policies/admin/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/email"), payload);

          case 3:
            res = _context40.sent;
            handleApiRequestSuccessData(res);
            return _context40.abrupt("return", [res.data]);

          case 8:
            _context40.prev = 8;
            _context40.t0 = _context40["catch"](0);
            return _context40.abrupt("return", handleRequestError(_context40.t0, payload));

          case 11:
          case "end":
            return _context40.stop();
        }
      }
    }, _callee40, null, [[0, 8]]);
  }));

  return function apiUpdatePolicyCustomerDetails(_x43) {
    return _ref43.apply(this, arguments);
  };
}(); // Query the information of the associated policy list

export var apiQueryAssociatedPolicyListInfo = /*#__PURE__*/function () {
  var _ref44 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee41$(_context41) {
      while (1) {
        switch (_context41.prev = _context41.next) {
          case 0:
            _context41.prev = 0;
            _context41.next = 3;
            return api.get("/policies/".concat(payload.policyId, "/related"));

          case 3:
            res = _context41.sent;
            handleApiRequestSuccessData(res);
            return _context41.abrupt("return", [res.data]);

          case 8:
            _context41.prev = 8;
            _context41.t0 = _context41["catch"](0);
            return _context41.abrupt("return", handleRequestError(_context41.t0, payload));

          case 11:
          case "end":
            return _context41.stop();
        }
      }
    }, _callee41, null, [[0, 8]]);
  }));

  return function apiQueryAssociatedPolicyListInfo(_x44) {
    return _ref44.apply(this, arguments);
  };
}(); // Send policy email

export var apiSendPolicyEmail = /*#__PURE__*/function () {
  var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee42$(_context42) {
      while (1) {
        switch (_context42.prev = _context42.next) {
          case 0:
            _context42.prev = 0;
            res = {
              data: null
            };
            _context42.next = 4;
            return api.get("/policies/admin/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/universal/update/send_quote_schedule_email"));

          case 4:
            res = _context42.sent;
            handleApiRequestSuccessData(res);
            return _context42.abrupt("return", [res.data]);

          case 9:
            _context42.prev = 9;
            _context42.t0 = _context42["catch"](0);
            return _context42.abrupt("return", handleRequestError(_context42.t0, payload));

          case 12:
          case "end":
            return _context42.stop();
        }
      }
    }, _callee42, null, [[0, 9]]);
  }));

  return function apiSendPolicyEmail(_x45) {
    return _ref45.apply(this, arguments);
  };
}(); // Debug mode: Modify policy info

export var apiDebugModifyPolicyInfo = /*#__PURE__*/function () {
  var _ref46 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(payload) {
    var params, res;
    return _regeneratorRuntime.wrap(function _callee43$(_context43) {
      while (1) {
        switch (_context43.prev = _context43.next) {
          case 0:
            _context43.prev = 0;
            params = _objectSpread({}, payload);
            delete params.policyId;
            _context43.next = 5;
            return api.patch("/policies/admin/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/policy-period?").concat(qs.stringify(params)));

          case 5:
            res = _context43.sent;
            handleApiRequestSuccessData(res);
            return _context43.abrupt("return", [res.data]);

          case 10:
            _context43.prev = 10;
            _context43.t0 = _context43["catch"](0);
            return _context43.abrupt("return", handleRequestError(_context43.t0, payload));

          case 13:
          case "end":
            return _context43.stop();
        }
      }
    }, _callee43, null, [[0, 10]]);
  }));

  return function apiDebugModifyPolicyInfo(_x46) {
    return _ref46.apply(this, arguments);
  };
}(); // Policy: Revert to the latest accepted terms

export var apiRevertPolicyToOriginalPolicyTerms = /*#__PURE__*/function () {
  var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee44$(_context44) {
      while (1) {
        switch (_context44.prev = _context44.next) {
          case 0:
            _context44.prev = 0;
            _context44.next = 3;
            return api["delete"]("/policies/admin/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/universal/update/revert"));

          case 3:
            res = _context44.sent;
            handleApiRequestSuccessData(res);
            return _context44.abrupt("return", [res.data]);

          case 8:
            _context44.prev = 8;
            _context44.t0 = _context44["catch"](0);
            return _context44.abrupt("return", handleRequestError(_context44.t0, payload));

          case 11:
          case "end":
            return _context44.stop();
        }
      }
    }, _callee44, null, [[0, 8]]);
  }));

  return function apiRevertPolicyToOriginalPolicyTerms(_x47) {
    return _ref47.apply(this, arguments);
  };
}(); // Policy: Payment info

export var apiGetPolicyPaymentAdjustment = /*#__PURE__*/function () {
  var _ref48 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(payload) {
    var _res$data9, _res$data10, res;

    return _regeneratorRuntime.wrap(function _callee45$(_context45) {
      while (1) {
        switch (_context45.prev = _context45.next) {
          case 0:
            _context45.prev = 0;
            _context45.next = 3;
            return api.get("/policies/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/get-payment-record"));

          case 3:
            res = _context45.sent;
            handleApiRequestSuccessData(res);
            res.data.payment_records = handlePolicyPaymentAdjustmentListInfo(((_res$data9 = res.data) === null || _res$data9 === void 0 ? void 0 : _res$data9.payment_records) || []);
            res.data.total_payment_records = handlePolicyPaymentAdjustmentListInfo(calculateTheTotalPaymentAdjustmentListInfo(((_res$data10 = res.data) === null || _res$data10 === void 0 ? void 0 : _res$data10.payment_records) || []));
            return _context45.abrupt("return", [res.data]);

          case 10:
            _context45.prev = 10;
            _context45.t0 = _context45["catch"](0);
            return _context45.abrupt("return", handleRequestError(_context45.t0, payload));

          case 13:
          case "end":
            return _context45.stop();
        }
      }
    }, _callee45, null, [[0, 10]]);
  }));

  return function apiGetPolicyPaymentAdjustment(_x48) {
    return _ref48.apply(this, arguments);
  };
}(); // Policy: Manually update a refund payment record's payment status (e.g. pending -> succeeded)

export var apiUpdatePolicyRefundPaymentStatus = /*#__PURE__*/function () {
  var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee46$(_context46) {
      while (1) {
        switch (_context46.prev = _context46.next) {
          case 0:
            _context46.prev = 0;
            _context46.next = 3;
            return api.patch("/policies/admin/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/refunds/").concat(payload === null || payload === void 0 ? void 0 : payload.paymentRecordId, "/payment-status"), payload);

          case 3:
            res = _context46.sent;
            handleApiRequestSuccessData(res);
            return _context46.abrupt("return", [res.data]);

          case 8:
            _context46.prev = 8;
            _context46.t0 = _context46["catch"](0);
            return _context46.abrupt("return", handleRequestError(_context46.t0, payload));

          case 11:
          case "end":
            return _context46.stop();
        }
      }
    }, _callee46, null, [[0, 8]]);
  }));

  return function apiUpdatePolicyRefundPaymentStatus(_x49) {
    return _ref49.apply(this, arguments);
  };
}();
export var apiDeclinePolicyReferral = /*#__PURE__*/function () {
  var _ref50 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee47$(_context47) {
      while (1) {
        switch (_context47.prev = _context47.next) {
          case 0:
            _context47.prev = 0;
            _context47.next = 3;
            return api.post("/policies/admin/".concat(payload.policyId, "/universal/decline"), payload);

          case 3:
            res = _context47.sent;
            handleApiRequestSuccessData(res);
            return _context47.abrupt("return", [res.data]);

          case 8:
            _context47.prev = 8;
            _context47.t0 = _context47["catch"](0);
            return _context47.abrupt("return", handleRequestError(_context47.t0, payload));

          case 11:
          case "end":
            return _context47.stop();
        }
      }
    }, _callee47, null, [[0, 8]]);
  }));

  return function apiDeclinePolicyReferral(_x50) {
    return _ref50.apply(this, arguments);
  };
}();
export var apiApprovalPolicyReferral = /*#__PURE__*/function () {
  var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee48$(_context48) {
      while (1) {
        switch (_context48.prev = _context48.next) {
          case 0:
            _context48.prev = 0;
            _context48.next = 3;
            return api.post("/policies/admin/".concat(payload.policyId, "/universal/approval-referral"), payload);

          case 3:
            res = _context48.sent;
            handleApiRequestSuccessData(res);
            return _context48.abrupt("return", [res.data]);

          case 8:
            _context48.prev = 8;
            _context48.t0 = _context48["catch"](0);
            return _context48.abrupt("return", handleRequestError(_context48.t0, payload));

          case 11:
          case "end":
            return _context48.stop();
        }
      }
    }, _callee48, null, [[0, 8]]);
  }));

  return function apiApprovalPolicyReferral(_x51) {
    return _ref51.apply(this, arguments);
  };
}();
export var apiSendPolicyReferralEmails = /*#__PURE__*/function () {
  var _ref52 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee49$(_context49) {
      while (1) {
        switch (_context49.prev = _context49.next) {
          case 0:
            _context49.prev = 0;
            _context49.next = 3;
            return api.post("/policies/admin/".concat(payload.policyId, "/universal/send_referral_email"));

          case 3:
            res = _context49.sent;
            handleApiRequestSuccessData(res);
            return _context49.abrupt("return", [res.data]);

          case 8:
            _context49.prev = 8;
            _context49.t0 = _context49["catch"](0);
            return _context49.abrupt("return", handleRequestError(_context49.t0, payload));

          case 11:
          case "end":
            return _context49.stop();
        }
      }
    }, _callee49, null, [[0, 8]]);
  }));

  return function apiSendPolicyReferralEmails(_x52) {
    return _ref52.apply(this, arguments);
  };
}();
export var apiDownloadPolicyQuoteScheduleAndPolicyWordingDocuments = /*#__PURE__*/function () {
  var _ref53 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee50$(_context50) {
      while (1) {
        switch (_context50.prev = _context50.next) {
          case 0:
            _context50.prev = 0;
            _context50.next = 3;
            return api.get("/policies/admin/download-update-quote-schedule/".concat(payload.policyId), {
              responseType: 'blob'
            });

          case 3:
            res = _context50.sent;
            handleApiRequestSuccessData(res);
            return _context50.abrupt("return", res);

          case 8:
            _context50.prev = 8;
            _context50.t0 = _context50["catch"](0);
            return _context50.abrupt("return", handleRequestError(_context50.t0, payload));

          case 11:
          case "end":
            return _context50.stop();
        }
      }
    }, _callee50, null, [[0, 8]]);
  }));

  return function apiDownloadPolicyQuoteScheduleAndPolicyWordingDocuments(_x53) {
    return _ref53.apply(this, arguments);
  };
}();
export var apiSavePolicyDraftDetailInfo = /*#__PURE__*/function () {
  var _ref54 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(payload) {
    var url, res;
    return _regeneratorRuntime.wrap(function _callee51$(_context51) {
      while (1) {
        switch (_context51.prev = _context51.next) {
          case 0:
            _context51.prev = 0;
            url = "/policies/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/universal/update/save");

            if ((payload === null || payload === void 0 ? void 0 : payload.apiSource) === JoveProjectTypeEnum.cms) {
              url = "/policies/admin/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/universal/update/save");
            }

            _context51.next = 5;
            return api.post(url, filterOutRequestExtraParameters(payload));

          case 5:
            res = _context51.sent;
            handleApiRequestSuccessData(res);
            return _context51.abrupt("return", [res.data]);

          case 10:
            _context51.prev = 10;
            _context51.t0 = _context51["catch"](0);
            return _context51.abrupt("return", handleRequestError(_context51.t0, payload));

          case 13:
          case "end":
            return _context51.stop();
        }
      }
    }, _callee51, null, [[0, 10]]);
  }));

  return function apiSavePolicyDraftDetailInfo(_x54) {
    return _ref54.apply(this, arguments);
  };
}();
export var apiSendPolicyScheduleAndWordingEmails = /*#__PURE__*/function () {
  var _ref55 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee52$(_context52) {
      while (1) {
        switch (_context52.prev = _context52.next) {
          case 0:
            _context52.prev = 0;
            _context52.next = 3;
            return api.post("/policies/admin/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/send-quote-schedule-and-wording"));

          case 3:
            res = _context52.sent;
            handleApiRequestSuccessData(res);
            return _context52.abrupt("return", [res.data]);

          case 8:
            _context52.prev = 8;
            _context52.t0 = _context52["catch"](0);
            return _context52.abrupt("return", handleRequestError(_context52.t0, payload));

          case 11:
          case "end":
            return _context52.stop();
        }
      }
    }, _callee52, null, [[0, 8]]);
  }));

  return function apiSendPolicyScheduleAndWordingEmails(_x55) {
    return _ref55.apply(this, arguments);
  };
}();
export var apiAcceptPolicyDraftAndUpdatePolicy = /*#__PURE__*/function () {
  var _ref56 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee53$(_context53) {
      while (1) {
        switch (_context53.prev = _context53.next) {
          case 0:
            _context53.prev = 0;
            _context53.next = 3;
            return api.post("/policies/accept_quote_and_update/".concat(payload.policyId));

          case 3:
            res = _context53.sent;
            handleApiRequestSuccessData(res);
            return _context53.abrupt("return", [res.data]);

          case 8:
            _context53.prev = 8;
            _context53.t0 = _context53["catch"](0);
            return _context53.abrupt("return", handleRequestError(_context53.t0, payload));

          case 11:
          case "end":
            return _context53.stop();
        }
      }
    }, _callee53, null, [[0, 8]]);
  }));

  return function apiAcceptPolicyDraftAndUpdatePolicy(_x56) {
    return _ref56.apply(this, arguments);
  };
}();
export var apiQueryPolicyDraftPrice = /*#__PURE__*/function () {
  var _ref57 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee54$(_context54) {
      while (1) {
        switch (_context54.prev = _context54.next) {
          case 0:
            _context54.prev = 0;
            _context54.next = 3;
            return api.get("/admin/quote_draft/get_price_by_draft/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId));

          case 3:
            res = _context54.sent;
            handleApiRequestSuccessData(res);
            return _context54.abrupt("return", [res.data]);

          case 8:
            _context54.prev = 8;
            _context54.t0 = _context54["catch"](0);
            return _context54.abrupt("return", handleRequestError(_context54.t0, payload));

          case 11:
          case "end":
            return _context54.stop();
        }
      }
    }, _callee54, null, [[0, 8]]);
  }));

  return function apiQueryPolicyDraftPrice(_x57) {
    return _ref57.apply(this, arguments);
  };
}();
export var apiCreateNewRecordPolicy = /*#__PURE__*/function () {
  var _ref58 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee55$(_context55) {
      while (1) {
        switch (_context55.prev = _context55.next) {
          case 0:
            _context55.prev = 0;
            _context55.next = 3;
            return api.post("/policies/admin/".concat(payload.policyId, "/universal/update/create"));

          case 3:
            res = _context55.sent;
            handleApiRequestSuccessData(res);
            return _context55.abrupt("return", [res.data]);

          case 8:
            _context55.prev = 8;
            _context55.t0 = _context55["catch"](0);
            return _context55.abrupt("return", handleRequestError(_context55.t0, payload));

          case 11:
          case "end":
            return _context55.stop();
        }
      }
    }, _callee55, null, [[0, 8]]);
  }));

  return function apiCreateNewRecordPolicy(_x58) {
    return _ref58.apply(this, arguments);
  };
}();
export var apiGetPolicyEffectiveUpdateDate = /*#__PURE__*/function () {
  var _ref59 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee56$(_context56) {
      while (1) {
        switch (_context56.prev = _context56.next) {
          case 0:
            _context56.prev = 0;
            _context56.next = 3;
            return api.get("/policies/admin/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/current_period"));

          case 3:
            res = _context56.sent;
            handleApiRequestSuccessData(res);
            return _context56.abrupt("return", [res.data]);

          case 8:
            _context56.prev = 8;
            _context56.t0 = _context56["catch"](0);
            return _context56.abrupt("return", handleRequestError(_context56.t0, payload));

          case 11:
          case "end":
            return _context56.stop();
        }
      }
    }, _callee56, null, [[0, 8]]);
  }));

  return function apiGetPolicyEffectiveUpdateDate(_x59) {
    return _ref59.apply(this, arguments);
  };
}();
export var apiUserUpdatePolicyInfo = /*#__PURE__*/function () {
  var _ref60 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee57$(_context57) {
      while (1) {
        switch (_context57.prev = _context57.next) {
          case 0:
            _context57.prev = 0;
            _context57.next = 3;
            return api.post("/policies/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/universal/update/create_and_save"), filterOutRequestExtraParameters(payload));

          case 3:
            res = _context57.sent;
            handleApiRequestSuccessData(res);
            return _context57.abrupt("return", [res.data]);

          case 8:
            _context57.prev = 8;
            _context57.t0 = _context57["catch"](0);
            return _context57.abrupt("return", handleRequestError(_context57.t0, payload));

          case 11:
          case "end":
            return _context57.stop();
        }
      }
    }, _callee57, null, [[0, 8]]);
  }));

  return function apiUserUpdatePolicyInfo(_x60) {
    return _ref60.apply(this, arguments);
  };
}();
export var apiQueryPolicyPreCancelInfo = /*#__PURE__*/function () {
  var _ref61 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee58$(_context58) {
      while (1) {
        switch (_context58.prev = _context58.next) {
          case 0:
            _context58.prev = 0;
            _context58.next = 3;
            return api.get("/policies/admin/".concat(payload === null || payload === void 0 ? void 0 : payload.policy_id, "/pre_cancel?").concat(qs.stringify(filterOutRequestExtraParameters(payload))));

          case 3:
            res = _context58.sent;
            handleApiRequestSuccessData(res);
            return _context58.abrupt("return", [res.data]);

          case 8:
            _context58.prev = 8;
            _context58.t0 = _context58["catch"](0);
            return _context58.abrupt("return", handleRequestError(_context58.t0, payload));

          case 11:
          case "end":
            return _context58.stop();
        }
      }
    }, _callee58, null, [[0, 8]]);
  }));

  return function apiQueryPolicyPreCancelInfo(_x61) {
    return _ref61.apply(this, arguments);
  };
}();
export var apiSavePrePolicyCancelInfo = /*#__PURE__*/function () {
  var _ref62 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(payload) {
    var _payload$files, formData, res;

    return _regeneratorRuntime.wrap(function _callee59$(_context59) {
      while (1) {
        switch (_context59.prev = _context59.next) {
          case 0:
            _context59.prev = 0;
            formData = new FormData();

            if (payload !== null && payload !== void 0 && payload.cancel_date) {
              formData.append('cancel_date', payload === null || payload === void 0 ? void 0 : payload.cancel_date);
            }

            if (payload !== null && payload !== void 0 && payload.reason) {
              formData.append('reason', payload === null || payload === void 0 ? void 0 : payload.reason);
            }

            if ((payload === null || payload === void 0 ? void 0 : (_payload$files = payload.files) === null || _payload$files === void 0 ? void 0 : _payload$files.length) > 0) {
              payload.files.forEach(function (file) {
                formData.append('files', file);
              });
            }

            _context59.next = 7;
            return api.post("/policies/admin/".concat(payload === null || payload === void 0 ? void 0 : payload.policy_id, "/pre_cancel"), formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });

          case 7:
            res = _context59.sent;
            handleApiRequestSuccessData(res);
            return _context59.abrupt("return", [res.data]);

          case 12:
            _context59.prev = 12;
            _context59.t0 = _context59["catch"](0);
            return _context59.abrupt("return", handleRequestError(_context59.t0, payload));

          case 15:
          case "end":
            return _context59.stop();
        }
      }
    }, _callee59, null, [[0, 12]]);
  }));

  return function apiSavePrePolicyCancelInfo(_x62) {
    return _ref62.apply(this, arguments);
  };
}();
export var apiGetPolicyUnconfirmedPaymentAdjustmentInfo = /*#__PURE__*/function () {
  var _ref63 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(payload) {
    var _res$data11, res;

    return _regeneratorRuntime.wrap(function _callee60$(_context60) {
      while (1) {
        switch (_context60.prev = _context60.next) {
          case 0:
            _context60.prev = 0;
            _context60.next = 3;
            return api.get("/policies/admin/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/change_info"));

          case 3:
            res = _context60.sent;
            handleApiRequestSuccessData(res);

            if (res !== null && res !== void 0 && (_res$data11 = res.data) !== null && _res$data11 !== void 0 && _res$data11.data && Object.keys(res.data.data).length > 0) {
              res.data.data = {
                list: [handlePolicyUnconfirmedPaymentAdjustmentInfoDataItem(res.data.data)]
              };
            }

            return _context60.abrupt("return", [res.data]);

          case 9:
            _context60.prev = 9;
            _context60.t0 = _context60["catch"](0);
            return _context60.abrupt("return", handleRequestError(_context60.t0, payload));

          case 12:
          case "end":
            return _context60.stop();
        }
      }
    }, _callee60, null, [[0, 9]]);
  }));

  return function apiGetPolicyUnconfirmedPaymentAdjustmentInfo(_x63) {
    return _ref63.apply(this, arguments);
  };
}();
export var apiSendPolicyUnconfirmedCancellationEmail = /*#__PURE__*/function () {
  var _ref64 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee61$(_context61) {
      while (1) {
        switch (_context61.prev = _context61.next) {
          case 0:
            _context61.prev = 0;
            _context61.next = 3;
            return api.get("/policies/admin/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/pre_cancel/send_email"));

          case 3:
            res = _context61.sent;
            handleApiRequestSuccessData(res);
            return _context61.abrupt("return", [res.data]);

          case 8:
            _context61.prev = 8;
            _context61.t0 = _context61["catch"](0);
            return _context61.abrupt("return", handleRequestError(_context61.t0, payload));

          case 11:
          case "end":
            return _context61.stop();
        }
      }
    }, _callee61, null, [[0, 8]]);
  }));

  return function apiSendPolicyUnconfirmedCancellationEmail(_x64) {
    return _ref64.apply(this, arguments);
  };
}();
export var apiGetPolicyDetailInfoWithNoAuth = /*#__PURE__*/function () {
  var _ref65 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee62$(_context62) {
      while (1) {
        switch (_context62.prev = _context62.next) {
          case 0:
            _context62.prev = 0;
            _context62.next = 3;
            return api.get("/policies/no_auth/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/detail"));

          case 3:
            res = _context62.sent;
            handlePolicyDetailInfoData(res);
            return _context62.abrupt("return", [res.data]);

          case 8:
            _context62.prev = 8;
            _context62.t0 = _context62["catch"](0);
            return _context62.abrupt("return", handleRequestError(_context62.t0, payload));

          case 11:
          case "end":
            return _context62.stop();
        }
      }
    }, _callee62, null, [[0, 8]]);
  }));

  return function apiGetPolicyDetailInfoWithNoAuth(_x65) {
    return _ref65.apply(this, arguments);
  };
}();
export var apiAddPolicyPaymentAdjustment = /*#__PURE__*/function () {
  var _ref66 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee63$(_context63) {
      while (1) {
        switch (_context63.prev = _context63.next) {
          case 0:
            _context63.prev = 0;
            _context63.next = 3;
            return api.post("/policies/admin/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/add_dispute"), filterOutRequestExtraParameters(payload));

          case 3:
            res = _context63.sent;
            handleApiRequestSuccessData(res);
            return _context63.abrupt("return", [res.data]);

          case 8:
            _context63.prev = 8;
            _context63.t0 = _context63["catch"](0);
            return _context63.abrupt("return", handleRequestError(_context63.t0, payload));

          case 11:
          case "end":
            return _context63.stop();
        }
      }
    }, _callee63, null, [[0, 8]]);
  }));

  return function apiAddPolicyPaymentAdjustment(_x66) {
    return _ref66.apply(this, arguments);
  };
}();
export var apiGetPolicyUserModifyPasswordLinkUrl = /*#__PURE__*/function () {
  var _ref67 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee64$(_context64) {
      while (1) {
        switch (_context64.prev = _context64.next) {
          case 0:
            _context64.prev = 0;
            _context64.next = 3;
            return api.get("/policies/admin/get_sign_up_or_reset_password_url?".concat(qs.stringify(filterOutRequestExtraParameters(payload))));

          case 3:
            res = _context64.sent;
            handleApiRequestSuccessData(res);
            return _context64.abrupt("return", [res.data]);

          case 8:
            _context64.prev = 8;
            _context64.t0 = _context64["catch"](0);
            return _context64.abrupt("return", handleRequestError(_context64.t0, payload));

          case 11:
          case "end":
            return _context64.stop();
        }
      }
    }, _callee64, null, [[0, 8]]);
  }));

  return function apiGetPolicyUserModifyPasswordLinkUrl(_x67) {
    return _ref67.apply(this, arguments);
  };
}();
export var apiCancelRenewalPolicy = /*#__PURE__*/function () {
  var _ref68 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee65$(_context65) {
      while (1) {
        switch (_context65.prev = _context65.next) {
          case 0:
            _context65.prev = 0;
            _context65.next = 3;
            return api.post("/policies/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/cancel-renewal"), payload);

          case 3:
            res = _context65.sent;
            handleApiRequestSuccessData(res);
            return _context65.abrupt("return", [res.data]);

          case 8:
            _context65.prev = 8;
            _context65.t0 = _context65["catch"](0);
            return _context65.abrupt("return", handleRequestError(_context65.t0, payload));

          case 11:
          case "end":
            return _context65.stop();
        }
      }
    }, _callee65, null, [[0, 8]]);
  }));

  return function apiCancelRenewalPolicy(_x68) {
    return _ref68.apply(this, arguments);
  };
}();
export var apiJudgeCurrentPolicyCanDirectlyCancel = /*#__PURE__*/function () {
  var _ref69 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee66$(_context66) {
      while (1) {
        switch (_context66.prev = _context66.next) {
          case 0:
            _context66.prev = 0;
            _context66.next = 3;
            return api.get("/policies/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/can_cancel"));

          case 3:
            res = _context66.sent;
            handleApiRequestSuccessData(res);
            return _context66.abrupt("return", [res.data]);

          case 8:
            _context66.prev = 8;
            _context66.t0 = _context66["catch"](0);
            return _context66.abrupt("return", handleRequestError(_context66.t0, payload));

          case 11:
          case "end":
            return _context66.stop();
        }
      }
    }, _callee66, null, [[0, 8]]);
  }));

  return function apiJudgeCurrentPolicyCanDirectlyCancel(_x69) {
    return _ref69.apply(this, arguments);
  };
}();
export var apiRequestCancelPolicyWithFileInfo = /*#__PURE__*/function () {
  var _ref70 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67(payload) {
    var _payload$fileList, formData, res;

    return _regeneratorRuntime.wrap(function _callee67$(_context67) {
      while (1) {
        switch (_context67.prev = _context67.next) {
          case 0:
            _context67.prev = 0;
            formData = new FormData();

            if (payload !== null && payload !== void 0 && payload.cancellation_date) {
              formData.append('cancellation_date', payload === null || payload === void 0 ? void 0 : payload.cancellation_date);
            }

            if (has(payload, 'is_apply')) {
              formData.append('is_apply', String(payload.is_apply));
            }

            if (has(payload, 'reason')) {
              formData.append('reason', payload.reason);
            }

            if ((payload === null || payload === void 0 ? void 0 : (_payload$fileList = payload.fileList) === null || _payload$fileList === void 0 ? void 0 : _payload$fileList.length) > 0) {
              payload.fileList.forEach(function (item) {
                formData.append('files', item);
              });
            }

            _context67.next = 8;
            return api.post("/policies/".concat(payload === null || payload === void 0 ? void 0 : payload.policy_id, "/cancel"), formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });

          case 8:
            res = _context67.sent;
            handleApiRequestSuccessData(res);
            return _context67.abrupt("return", [res.data]);

          case 13:
            _context67.prev = 13;
            _context67.t0 = _context67["catch"](0);
            return _context67.abrupt("return", handleRequestError(_context67.t0, payload));

          case 16:
          case "end":
            return _context67.stop();
        }
      }
    }, _callee67, null, [[0, 13]]);
  }));

  return function apiRequestCancelPolicyWithFileInfo(_x70) {
    return _ref70.apply(this, arguments);
  };
}();
export var apiApproveUserRequestCancelPolicy = /*#__PURE__*/function () {
  var _ref71 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee68$(_context68) {
      while (1) {
        switch (_context68.prev = _context68.next) {
          case 0:
            _context68.prev = 0;
            _context68.next = 3;
            return api.post("/policies/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/approve_or_decline_cancellation"), payload);

          case 3:
            res = _context68.sent;
            handleApiRequestSuccessData(res);
            return _context68.abrupt("return", [res.data]);

          case 8:
            _context68.prev = 8;
            _context68.t0 = _context68["catch"](0);
            return _context68.abrupt("return", handleRequestError(_context68.t0, payload));

          case 11:
          case "end":
            return _context68.stop();
        }
      }
    }, _callee68, null, [[0, 8]]);
  }));

  return function apiApproveUserRequestCancelPolicy(_x71) {
    return _ref71.apply(this, arguments);
  };
}();
export var apiGetUserRequestCancelUploadDocumentList = /*#__PURE__*/function () {
  var _ref72 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee69$(_context69) {
      while (1) {
        switch (_context69.prev = _context69.next) {
          case 0:
            _context69.prev = 0;
            _context69.next = 3;
            return api.get("/policies/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/cancel/documents"));

          case 3:
            res = _context69.sent;
            handleApiRequestSuccessData(res);

            if (isArray(res === null || res === void 0 ? void 0 : res.data)) {
              res.data = res.data.map(function (item) {
                var _convertBytes;

                return _objectSpread(_objectSpread({}, item), {}, {
                  id: item.documentId,
                  value: item.documentId,
                  title: item.filename,
                  download_url: item.url,
                  canDownload: true,
                  sizeText: "".concat((_convertBytes = convertBytes(item.byteSize)) === null || _convertBytes === void 0 ? void 0 : _convertBytes.MB, " MB")
                });
              });
            }

            return _context69.abrupt("return", [res.data]);

          case 9:
            _context69.prev = 9;
            _context69.t0 = _context69["catch"](0);
            return _context69.abrupt("return", handleRequestError(_context69.t0, payload));

          case 12:
          case "end":
            return _context69.stop();
        }
      }
    }, _callee69, null, [[0, 9]]);
  }));

  return function apiGetUserRequestCancelUploadDocumentList(_x72) {
    return _ref72.apply(this, arguments);
  };
}();
export var apiDeleteUserRequestCancelPolicyUploadedDocument = /*#__PURE__*/function () {
  var _ref73 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee70$(_context70) {
      while (1) {
        switch (_context70.prev = _context70.next) {
          case 0:
            _context70.prev = 0;
            _context70.next = 3;
            return api["delete"]("/policies/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/documents?").concat(qs.stringify(payload)));

          case 3:
            res = _context70.sent;
            handleApiRequestSuccessData(res);
            return _context70.abrupt("return", [res.data]);

          case 8:
            _context70.prev = 8;
            _context70.t0 = _context70["catch"](0);
            return _context70.abrupt("return", handleRequestError(_context70.t0, payload));

          case 11:
          case "end":
            return _context70.stop();
        }
      }
    }, _callee70, null, [[0, 8]]);
  }));

  return function apiDeleteUserRequestCancelPolicyUploadedDocument(_x73) {
    return _ref73.apply(this, arguments);
  };
}();
export var apiUpdatePolicyInfo = /*#__PURE__*/function () {
  var _ref74 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee71$(_context71) {
      while (1) {
        switch (_context71.prev = _context71.next) {
          case 0:
            _context71.prev = 0;
            _context71.next = 3;
            return api.patch("/policies/admin/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId), payload);

          case 3:
            res = _context71.sent;
            handleApiRequestSuccessData(res);
            return _context71.abrupt("return", [res.data]);

          case 8:
            _context71.prev = 8;
            _context71.t0 = _context71["catch"](0);
            return _context71.abrupt("return", handleRequestError(_context71.t0, payload));

          case 11:
          case "end":
            return _context71.stop();
        }
      }
    }, _callee71, null, [[0, 8]]);
  }));

  return function apiUpdatePolicyInfo(_x74) {
    return _ref74.apply(this, arguments);
  };
}();
export var apiDownloadPolicyCancellationFiles = /*#__PURE__*/function () {
  var _ref75 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee72$(_context72) {
      while (1) {
        switch (_context72.prev = _context72.next) {
          case 0:
            _context72.prev = 0;
            _context72.next = 3;
            return api.get("/policies/admin/get-cancellation-document/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId), {
              responseType: 'blob'
            });

          case 3:
            res = _context72.sent;
            handleApiRequestSuccessData(res);
            return _context72.abrupt("return", res);

          case 8:
            _context72.prev = 8;
            _context72.t0 = _context72["catch"](0);
            return _context72.abrupt("return", handleRequestError(_context72.t0, payload));

          case 11:
          case "end":
            return _context72.stop();
        }
      }
    }, _callee72, null, [[0, 8]]);
  }));

  return function apiDownloadPolicyCancellationFiles(_x75) {
    return _ref75.apply(this, arguments);
  };
}();
export var apiGetPolicyPaidInformation = /*#__PURE__*/function () {
  var _ref76 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee73(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee73$(_context73) {
      while (1) {
        switch (_context73.prev = _context73.next) {
          case 0:
            _context73.prev = 0;
            _context73.next = 3;
            return api.get("/policies/".concat(payload.policyId, "/get-renewal-paid-time"));

          case 3:
            res = _context73.sent;
            handleApiRequestSuccessData(res);
            return _context73.abrupt("return", [res === null || res === void 0 ? void 0 : res.data]);

          case 8:
            _context73.prev = 8;
            _context73.t0 = _context73["catch"](0);
            return _context73.abrupt("return", handleRequestError(_context73.t0, payload));

          case 11:
          case "end":
            return _context73.stop();
        }
      }
    }, _callee73, null, [[0, 8]]);
  }));

  return function apiGetPolicyPaidInformation(_x76) {
    return _ref76.apply(this, arguments);
  };
}();
export var apiMarkCancelledPolicyCommissionAdjusted = /*#__PURE__*/function () {
  var _ref77 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee74(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee74$(_context74) {
      while (1) {
        switch (_context74.prev = _context74.next) {
          case 0:
            _context74.prev = 0;
            _context74.next = 3;
            return api.post("/policies/admin/quote/policy-cancellation-commission-adjusted?".concat(qs.stringify(payload)), payload);

          case 3:
            res = _context74.sent;
            handleApiRequestSuccessData(res);
            return _context74.abrupt("return", [res === null || res === void 0 ? void 0 : res.data]);

          case 8:
            _context74.prev = 8;
            _context74.t0 = _context74["catch"](0);
            return _context74.abrupt("return", handleRequestError(_context74.t0, payload));

          case 11:
          case "end":
            return _context74.stop();
        }
      }
    }, _callee74, null, [[0, 8]]);
  }));

  return function apiMarkCancelledPolicyCommissionAdjusted(_x77) {
    return _ref77.apply(this, arguments);
  };
}();
export var apiReinstateCancelledPolicy = /*#__PURE__*/function () {
  var _ref78 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee75(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee75$(_context75) {
      while (1) {
        switch (_context75.prev = _context75.next) {
          case 0:
            _context75.prev = 0;
            _context75.next = 3;
            return api.post("/policies/admin/".concat(payload.policyId, "/reinstatement"));

          case 3:
            res = _context75.sent;
            handleApiRequestSuccessData(res);
            return _context75.abrupt("return", [res === null || res === void 0 ? void 0 : res.data]);

          case 8:
            _context75.prev = 8;
            _context75.t0 = _context75["catch"](0);
            return _context75.abrupt("return", handleRequestError(_context75.t0, payload));

          case 11:
          case "end":
            return _context75.stop();
        }
      }
    }, _callee75, null, [[0, 8]]);
  }));

  return function apiReinstateCancelledPolicy(_x78) {
    return _ref78.apply(this, arguments);
  };
}();
export var apiUpdatePolicyPremium = /*#__PURE__*/function () {
  var _ref79 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee76(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee76$(_context76) {
      while (1) {
        switch (_context76.prev = _context76.next) {
          case 0:
            _context76.prev = 0;
            _context76.next = 3;
            return api.post("/policies/admin/".concat(payload.policyId, "/premium-change"), payload);

          case 3:
            res = _context76.sent;
            handleApiRequestSuccessData(res);
            return _context76.abrupt("return", [res === null || res === void 0 ? void 0 : res.data]);

          case 8:
            _context76.prev = 8;
            _context76.t0 = _context76["catch"](0);
            return _context76.abrupt("return", handleRequestError(_context76.t0, payload));

          case 11:
          case "end":
            return _context76.stop();
        }
      }
    }, _callee76, null, [[0, 8]]);
  }));

  return function apiUpdatePolicyPremium(_x79) {
    return _ref79.apply(this, arguments);
  };
}();